import { render, staticRenderFns } from "./FormDefault.vue?vue&type=template&id=1fecb3ce"
import script from "./FormDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormDefault.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports